import React from 'react'
import styled from 'styled-components'

import { VARIANT_SECONDARY } from '../../constants/variants'

import { Button } from './Button'
import { Modal } from './Modal'
import { Margin } from './Margin'

export const ConfirmModal = ({
  onCloseRequest, children, title, titleTrad, onConfirm, confirmDisabled,
}) => (
  <Modal onCloseRequest={onCloseRequest} title={title} titleTrad={titleTrad}>
    {children}
    <Margin v={10} />
    <ButtonSection>
      <Button onClick={onCloseRequest} variant={VARIANT_SECONDARY} tradId="cancel" />
      <Margin h={10} />
      <Button filled onClick={onConfirm} disabled={confirmDisabled} variant={VARIANT_SECONDARY} tradId="confirm" />
    </ButtonSection>
  </Modal>
)

const ButtonSection = styled.div`
  display: flex;
  justify-content: flex-end;
  @media (max-width: 500px) {
    flex-direction: column;
  }
`
